import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Row, Col } from 'react-bootstrap';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';

import ContentsThumbnail from './ContentsThumbnail';
import Confirm from '../Dialog/Confirm';
import Popup from '../Dialog/Popup'
import { history } from '../../helpers';
import { boardService } from '../../services';
import { alertActions } from '../../modules/alert';

class ContentsMod extends Component {
    constructor(props) {
        super(props);
        if (!props.location.state) history.goBack();
        const { board, boardInfo } = props.location.state;
        const { mySite } = props;
        this.state = {
            siteID: mySite.mySiteID,
            boardInfo: boardInfo,
            boardID: board.boardID,
            boardInfoID: board.boardInfoID,
            contentKindCode: board.contentKindCode,
            title: '',
            content: '',
            attachedFiles: [""],
            thumbnailFiles: [],
            uploadFiles: '',
            valueChange: false,
            extCheck: false,
            submitted: false,
            message: '',
            kind: '',
            open: false,
            open2: false,
        }
        
        this.readBoard(board.boardID);
    }

    readBoard = (boardID) => {
        boardService.readBoard(boardID)
            .then((response) => {
                this.setState({
                    ...this.state,
                    siteID: response.data.siteID,
                    boardInfoID: response.data.boardInfoID,
                    contentKindCode: response.data.contentKindCode,
                    title: response.data.title,
                    content: response.data.content,
                    attachedFiles: response.data.attachedFiles,
                    thumbnailFiles: response.data.thumbnailFiles,
                });
            })
            .catch(this.handleErrors);
    };

    handleValueChange = (e) => {
        // title 100자 체크
        if (e.target.name === "title" && e.target.value.length > 100) {
            this.props.errorAlerts("경고 100자 초과");
        }
        else {
            this.setState({
                valueChange: true,
                [e.target.name]: e.target.value
            },() => {this.handleExtCheck();});
        }
    };

    enterPressed = (e) => {
        let code = e.keyCode || e.which;
        if (code === 13) { //13 is the enter keycode
            this.buttonAdd.click();
        }
    };

    handleFileChange = (e) => {
        this.setState({
            valueChange: true,
            extCheck: false,
            [e.target.name]: e.target.files[0] ? e.target.files[0] : this.state.uploadFiles,
        },() => {this.handleExtCheck();});
    };

    // uploadFiles의 확장자 체크
    handleExtCheck = () => {
        let extCheck = false;
        let uploadFilesExt = "";
        const { contentKindCode, uploadFiles, attachedFiles } = this.state;
        let attachedFilesExt = (attachedFiles && attachedFiles.length > 0 && attachedFiles[0].originFileName ? attachedFiles[0].originFileName.substr(-4).toUpperCase() : "");
        if (uploadFiles !== "") {
            uploadFilesExt = (uploadFiles.name.substr(-4).toUpperCase() || "");
            attachedFilesExt = ""
        }

        if (contentKindCode === "CK002") {
            if ((uploadFilesExt === "" || uploadFilesExt === ".JPG" || uploadFilesExt === ".PNG") && (attachedFilesExt === "" || attachedFilesExt === ".JPG" || attachedFilesExt === ".PNG")) extCheck = true;
        }
        else if (contentKindCode === "CK003") {
            if ((uploadFilesExt === "" || uploadFilesExt === ".MP4") && (attachedFilesExt === "" || attachedFilesExt === ".MP4")) extCheck = true;
        }

        this.setState({
            extCheck: extCheck
        });

        return extCheck;
    };


    handleFormSubmit = (e) => {
        e.preventDefault();
        const { boardID, title, kind } = this.state;

        if (kind === "mod") {
            this.setState({
                extCheck: false,
                submitted: true
            });
            if (title) {
                if (this.handleExtCheck()) {
                    this.modBoard();
                }
            }
        }
        if (kind === "del") {
            let formData = new FormData();
            formData.append('boardID', boardID);
            boardService.checkOpbContent(formData)
                .then(response => {
                    if ((response.data && response.data.checkFlag) === "Y") {
                        // 배포O 인 경우
                        this.props.errorAlerts('해당 게시물은 배포중입니다. 배포중지 후 삭제 하세요.');
                    }
                    else {
                        //배포X 인 경우
                        this.delBoard(boardID);
                    }
                })
                .catch(this.handleErrors)
        }
    };

    modBoard = () => {
        const { myInfo } = this.props;
        const { siteID, boardID, boardInfoID, content, contentKindCode, title, uploadFiles } = this.state;

        let formData = new FormData();
        formData.append('siteID', siteID);
        formData.append('boardID', boardID);
        formData.append('boardInfoID', boardInfoID);
        formData.append('content', content);
        formData.append('contentKindCode', contentKindCode);
        formData.append('userID', myInfo.userID);
        if (contentKindCode !== "CK001") {
            formData.append('title', title);
            if (uploadFiles !== "") formData.append('uploadFiles', uploadFiles);
        }

        boardService.modBoard(formData)
            .then(response => {
                if (response.status === 200) {
                    // 배포 중인 컨텐츠 여부 확인
                    let formData2 = new FormData();
                    formData2.append('boardID', boardID);
                    boardService.checkOpbContent(formData2)
                        .then(response2 => {
                            if ((response2.data && response2.data.checkFlag) === "Y") {
                                // 배포 중인 컨텐츠를 수정하는 경우 알림창 팝업
                                this.setState({
                                    kind: "mod",
                                    open2: true
                                })
                            }
                            else {
                                this.handleGoBack();
                            }
                        })
                        .catch(this.handleErrors)
                }
            })
            .catch(this.handleErrors);
    };

    delBoard = (boardID) => {
        boardService.delBoard(boardID)
            .then((response) => {
                if (response.data.result === 1) {
                    this.setState({
                        kind: "del",
                        open2: true
                    });
                }
                else {
                    this.props.errorAlerts('게시물 삭제를 실패하였습니다.');
                }
            })
            .catch(this.handleErrors);
    };

    handleErrors = (error) => {
        console.log(error.toString());
        if (error.response === undefined)
            this.props.errorAlerts("알 수 없는 오류가 발생하였습니다. 관리자에게 문의하시기 바랍니다.", "/home");
        else {
            if (error.response.status === 401)
                this.props.errorAlerts("권한이 없습니다.", "/login");
            else
                this.props.errorAlerts(error.response.data.message);
        }
    };

    handleModButton = () => {
        this.setState({
            message: "수정 하시겠습니까?",
            kind: "mod",
            open: true
        });
    };

    handleDelButton = () => {
        this.setState({
            message: "해당 컨텐츠를 삭제하시겠습니까?",
            kind: "del",
            open: true
        });
    };

    handleClose = () => {
        if (this.state.valueChange) {
            this.setState({
                message: "취소하시겠습니까?\n입력된 정보는 삭제됩니다.",
                kind: "fail",
                open: true
            });
        }
        else {
            this.handleGoBack();
        }
    };

    handleGoBack = () => {
        history.goBack();
    };

    handleConfirmClose = () => {
        this.setState({
            message: "",
            kind: "",
            open: false
        })
    };

    render() {
        const { boardID, boardInfo, contentKindCode, title, uploadFiles, attachedFiles, thumbnailFiles, extCheck, submitted } = this.state;
        return (
            <>
                <h2 className="s-page-tit">
                    {boardInfo && boardInfo.boardName}
                </h2>
                <div className="search-result-wrapper contents-mod s-normal-box">
                    <Row>
                        <Col xs={3} md={1} lg={1} className="contents-mod-title">제목 <span className="text-color-red">*</span><br /><span className="contents-mod-title-length">({title.length}/100)</span></Col>
                        <Col xs={9} md={5} lg={5} className="text-align-left">
                            <input className="w100per padding-l10" type="text" name="title" value={title} onChange={this.handleValueChange} onKeyPress={this.enterPressed} />
                            {submitted && !title &&
                                <div className="text-color-red">* 제목을 입력하세요.</div>
                            }
                        </Col>
                        <Col xs={3} md={1} lg={1} className="contents-mod-title">유형 <span className="text-color-red">*</span></Col>
                        <Col xs={9} md={5} lg={5}>
                            <RadioGroup name="contentKindCode" value={contentKindCode} onChange={this.handleValueChange}>
                                <FormControlLabel name="contentKindCode" value="CK002" control={<Radio color="primary" />} label="이미지"/>
                                <FormControlLabel name="contentKindCode" value="CK003" control={<Radio color="primary" />} label="영상"/>
                            </RadioGroup>
                        </Col>
                    </Row>
                    <Row>
                        <Col xs={3} md={1} lg={1} className="contents-mod-title">
                            {contentKindCode === "CK002" ? "이미지" : "영상"} <span className="text-color-red">*</span>
                        </Col>
                        <Col xs={9} md={5} lg={5} className="text-align-left">
                            <label className="w100per">
                                <input className="contents-input-file" type="file" name="uploadFiles" onChange={this.handleFileChange} />
                                <div className="contents-input-file-name">{(uploadFiles.length !== 0 && uploadFiles.name) || ((attachedFiles.length !== 0 && attachedFiles[(attachedFiles.length - 1)].originFileName) || "JPG,PNG만 가능")}</div>
                                <div className="contents-input-file-button">첨부하기</div>
                            </label>
                            {submitted && !extCheck &&
                                <div className="text-color-red">* 확장자를 확인하세요.</div>
                            }
                        </Col>
                        {contentKindCode === "CK003" &&
                        <Col xs={12} md={5} lg={5} className="text-align-left contents-mng">
                            {!uploadFiles && thumbnailFiles.length > 0 &&
                                <ContentsThumbnail contentKindCode={contentKindCode} boardID={boardID} boardFileID={thumbnailFiles[(thumbnailFiles.length - 1)].boardFileID} />
                            }
                        </Col>
                        }
                    </Row>
                </div>
                <div className="search-button-wrapper text-align-right">
                    <button className={`button w100-button margin-r10 ${!this.state.valueChange && "disabled-button"}`} onClick={this.handleModButton} ref={button => this.buttonAdd = button} disabled={!this.state.valueChange}>수정</button>
                    <button className="button w100-button margin-r10" name="삭제" onClick={this.handleDelButton}>삭제</button>
                    <button className="button w100-button white-button" onClick={this.handleClose}>닫기</button>
                </div>
                {this.state.open === true &&
                    <Confirm message={this.state.message} kind={this.state.kind} handleFormSubmit={this.state.kind === "fail" ? this.handleGoBack : this.handleFormSubmit} handleClose={this.handleConfirmClose} />
                }
                {this.state.open2 === true &&
                    <Popup message={this.state.kind === "mod" ? "수정되었습니다. 새로 배포하세요." : "게시물을 삭제했습니다."} stateRefresh={this.handleGoBack} />
                }
            </>
        )
    }
}

function mapState(state) {
    const { userinfo, mySite } = state;
    const myInfo = userinfo.item;
    return { myInfo, mySite };
}

const actionCreators = {
    errorAlerts: alertActions.error,
    successAlerts: alertActions.success
};

export default connect(mapState, actionCreators)(ContentsMod);